import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { injectIntl, defineMessages } from 'react-intl';
import CSSTransitionGroup from 'react-transition-group/CSSTransitionGroup';
import Scrollbar from 'libs/Scrollbar';

import { Icon, Image, List, Message, Label } from 'semantic-ui-react';
import { TextField, Tooltip, IconButton } from 'material-ui';

import {
  ExamSummaryItem,
  ModalExamEdit,
  ModalExamDelete,
  ModalExamResend,
  ModalExamEnd,
  Loading,
  Button
} from 'components';

import styles from './ExamSummary.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

// const ExamSummary = ({ examSummary, onToggleExamSummary }) => {
class ExamSummary extends Component {
  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      examSummaryOrdering,
      examSummaryByExamNo,
      isAllOpen,
      isLoading,
      isOpen,
      selectedExamSummaryNo,
      formExamEdit
    } = this.props;
    // function
    const {
      onSelectExamSummary,
      onSelectEachInfo,
      onToggleExamSummary,
      onInfectionFilter,
      onExamToggleModal,
      // 훈련 즉시 실행, 종료
      onExamNow,
      // 메일 발송 정지, 재시작
      onExamPause
    } = this.props;
    // modal
    const { isModal, isClicked, isEditExamData, onToggleModal, onExamDelete, onExamResend, onExamEdit } = this.props;

    // 필터
    const { filter } = this.props;

    // search
    const { searchProps } = this.props;

    const ExamSummaryComponent = [];
    if (examSummaryOrdering.size > 0) {
      const groupClass = {};
      const esArray = examSummaryOrdering.toJS();
      for (let i = 0, l = esArray.length; i < l; i++) {
        const prevNo = i > 0 ? Number(examSummaryByExamNo.get(String(esArray[i - 1])).get('parentsExamNo')) : null;
        const peNo = Number(examSummaryByExamNo.get(String(esArray[i])).get('parentsExamNo'));
        const nextNo =
          l > 1 && l > i + 1 ? Number(examSummaryByExamNo.get(String(esArray[i + 1])).get('parentsExamNo')) : null;
        const examNo = esArray[i];

        if (peNo) {
          if (peNo !== prevNo && peNo === nextNo) {
            groupClass[examNo] = 'first-group';
          }

          if (peNo === prevNo && peNo !== nextNo) {
            groupClass[examNo] = 'last-group';
          }

          if (peNo !== prevNo && peNo !== nextNo) {
            groupClass[examNo] = 'first-group last-group';
          }
        }
      }

      examSummaryOrdering.map(
        // 컴포넌트로 매핑
        (examNo, index) =>
          ExamSummaryComponent.push(
            <ExamSummaryItem
              key={index}
              exam={examSummaryByExamNo.get(String(examNo))}
              groupClass={groupClass[examNo]}
              isOpen={!!(isOpen.indexOf(Number(examNo)) !== -1)}
              selected={String(selectedExamSummaryNo) === String(examNo)}
              onSelectExamSummary={onSelectExamSummary}
              onSelectEachInfo={onSelectEachInfo}
              onToggleExamSummary={onToggleExamSummary}
              onExamToggleModal={onExamToggleModal}
              onExamPause={onExamPause}
            />
          )
      );
    }

    return (
      <div className={cx('examSummary-wrapper')}>
        {/* 훈련 수정 모달 */}
        {isModal === 'examEdit' && (
          <ModalExamEdit
            visible
            isClicked={isClicked}
            onExamEdit={onExamEdit}
            onToggleModal={onToggleModal}
            selectedExam={isEditExamData}
            formExamEdit={formExamEdit}
          />
        )}
        {/* 훈련 삭제 모달 */}
        {isModal === 'examDelete' && (
          <ModalExamDelete
            visible
            isClicked={isClicked}
            onExamDelete={onExamDelete}
            onToggleModal={onToggleModal}
            selectedExam={isEditExamData}
          />
        )}
        {/* 알림 모달 - 훈련 즉시 실행, 종료 */}
        {(isModal === 'isStartNow' || isModal === 'isEndNow') && (
          <ModalExamEnd
            visible
            isClicked={isClicked}
            headerTitle={
              isModal === 'isStartNow'
                ? defineMessages(formatMessage({ id: 'CtExamSummary_2', defaultMessage: '훈련 즉시 실행' }))
                : defineMessages(formatMessage({ id: 'CtExamSummary_3', defaultMessage: '훈련 즉시 종료' }))
            }
            onConfirm={() => onExamNow(isEditExamData.get('examNo'), isModal)}
            onToggleModal={onToggleModal}>
            <div className={cx('message-header')}>
              {isModal === 'isStartNow'
                ? defineMessages(
                  formatMessage({ id: 'CtExamSummary_6', defaultMessage: '훈련을 즉시 실행 하시겠습니까?' })
                )
                : defineMessages(
                  formatMessage({ id: 'CtExamSummary_7', defaultMessage: '훈련을 즉시 종료 하시겠습니까?' })
                )}
            </div>
            <Message className={cx('template-detail-box')}>
              <div className={cx('template-detail')}>
                <List bulleted className={cx('template-detail-list')}>
                  <List.Item className={cx('template-detail-item')}>
                    <div className={cx('template-detail-item-title')}>
                      {defineMessages(formatMessage({ id: 'ModalExamDelete_5', defaultMessage: '훈련 번호' }))}
                    </div>
                    {isEditExamData.get('examNo')}
                  </List.Item>
                  <List.Item className={cx('template-detail-item')}>
                    <div className={cx('template-detail-item-title')}>
                      {defineMessages(formatMessage({ id: 'ModalExamDelete_6', defaultMessage: '훈련명' }))}
                    </div>
                    {isEditExamData.get('examName')}
                  </List.Item>
                </List>
              </div>
            </Message>
          </ModalExamEnd>
        )}
        {/* 훈련메일 재전송 모달 */}
        {(isModal === 'examResend' || isModal === 'failTargetExamResend') && (
          <ModalExamResend
            visible
            isClicked={isClicked}
            isModal={isModal}
            onExamResend={onExamResend}
            onToggleModal={onToggleModal}
            selectedExam={isEditExamData}
          />
        )}
        <div className={cx('examSummary-title')}>
          {isLoading && (
            <div className={cx('Loading')}>
              <Loading content={'Loading...'} noInverted />
            </div>
          )}
          <div
            className={cx('examSummary-title-inner', 'examSummary-all', { selected: selectedExamSummaryNo === 'all' })}
            onClick={e => onSelectExamSummary('all')}>
            <div className={cx('title-inner')}>
              <div className={cx('bt-exam-all')}>
                <Image className={cx('ui image')} src="/img/exam/cate_all.png" />
                <span>{defineMessages(formatMessage({ id: 'ExamSummary_6', defaultMessage: '전체 훈련' }))}</span>
              </div>
              <div className={cx('title-bt-area')}>
                <Tooltip
                  title={
                    !!isAllOpen
                      ? defineMessages(formatMessage({ id: 'ExamSummary_4', defaultMessage: '전체 닫기' }))
                      : defineMessages(formatMessage({ id: 'ExamSummary_5', defaultMessage: '전체 열기' }))
                  }
                  classes={{ tooltip: 'tooltip-noMaxWidth' }}
                  placement="bottom">
                  <IconButton
                    className={cx('bt-toggleAllView')}
                    onClick={e => {
                      e.stopPropagation();
                      onToggleExamSummary();
                    }}>
                    <Image src={!!isAllOpen ? '/img/exam/cate_close.png' : '/img/exam/cate_open.png'} />
                  </IconButton>
                </Tooltip>
              </div>
            </div>
          </div>
          {/* active={attachCategory === 1} */}
          <div className={cx('examSummary-filter')}>
            <div className={cx('examSummary-filter-inner')}>
              <div
                className={cx('examSummary-filter-line', !!filter && !!filter.infection ? 'on' : '')}
                onClick={() => onInfectionFilter('infection')}>
                <div className={cx('icon-filter')} />
                <span>
                  {defineMessages(formatMessage({ id: 'ExamSummary_7', defaultMessage: '감염이 있는 훈련' }))}
                </span>
              </div>
              <div
                className={cx('examSummary-filter-line', !!filter && !!filter.examEnd ? 'on' : '')}
                onClick={() => onInfectionFilter('examEnd')}>
                <div className={cx('icon-filter')} />
                <span>{defineMessages(formatMessage({ id: 'ExamSummary_8', defaultMessage: '완료된 훈련' }))}</span>
              </div>
              <div
                className={cx('examSummary-filter-line', !!filter && !!filter.examIng ? 'on' : '')}
                onClick={() => onInfectionFilter('examIng')}>
                <div className={cx('icon-filter')} />
                <span>{defineMessages(formatMessage({ id: 'ExamSummary_9', defaultMessage: '진행중인 훈련' }))}</span>
              </div>
              <div
                className={cx('examSummary-filter-line', !!filter && !!filter.examReserve ? 'on' : '')}
                onClick={() => onInfectionFilter('examReserve')}>
                <div className={cx('icon-filter')} />
                <span>{defineMessages(formatMessage({ id: 'ExamSummary_10', defaultMessage: '예약 훈련' }))}</span>
              </div>
              <div
                className={cx('examSummary-filter-line', 'filter-search', searchProps.isSearchActive ? 'on' : '')}
                onClick={searchProps.onSearchActive}>
                <div className={cx('icon-filter')} />
                <div className={cx('filter-search-text')}>
                  {searchProps.isSearchActive ? (
                    <div className={cx('search-area-wrap', searchProps.isSearchActive ? 'on' : '')}>
                      <div className={cx('search-area')}>
                        <TextField
                          autoFocus
                          className={cx('input-search')}
                          // value={searchProps.searchText}
                          onKeyUp={searchProps.onKeyupSearch}
                          onChange={e => searchProps.onChangeSearch(e.target.value)}
                          inputRef={searchProps.searchTextRef}
                          onBlur={searchProps.onSearchBlur}
                        />
                        <div className={cx('bt-area-wrap')}>
                          <Button
                            icon
                            title={defineMessages(formatMessage({ id: 'ExamSearch_17', defaultMessage: '검색' }))}
                            size="small"
                            onClick={e => {
                              e.stopPropagation();
                              searchProps.onSearch();
                            }}>
                            <Image src="/img/exam/cate_search.png" />
                          </Button>
                          <Button
                            icon
                            title={defineMessages(formatMessage({ id: 'TagItem_2', defaultMessage: '취소' }))}
                            size="small"
                            onClick={e => {
                              e.stopPropagation();
                              searchProps.onClearSearch();
                            }}>
                            <Image className={cx('cate-cancel')} src="/img/exam/cate_cancel.png" />
                          </Button>
                        </div>
                      </div>
                    </div>
                  ) : (
                      defineMessages(formatMessage({ id: 'ExamSearch_17', defaultMessage: '검색' }))
                    )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={cx('examSummary-content')}>
          {/* <Scrollbar autoHide color="white"> */}
          {/* ref={scroll => this.props.scrollRef(scroll)} onScroll={this.props.onScroll} */}
          <div className={cx('examSummary-content-inner')}>
            <div className={cx('each-exam')}>
              {ExamSummaryComponent.length > 0 ? (
                ExamSummaryComponent
              ) : (
                  <div className={cx('examSummary-noExam')}>
                    {defineMessages(formatMessage({ id: 'ExamList_1', defaultMessage: '훈련이 없습니다' }))}
                  </div>
                )}
            </div>
          </div>
          {/* </Scrollbar> */}
        </div>
      </div>
    );
  }
}

ExamSummary.propTypes = {
  exam: ImmutablePropTypes.mapContains({
    examNo: PropTypes.number,
    examName: PropTypes.string,
    examStartEpoch: PropTypes.number,
    examEndEpoch: PropTypes.number,
    target: PropTypes.number,
    read: PropTypes.number,
    download: PropTypes.number,
    infection: PropTypes.number,
    attach: PropTypes.number
  }),
  onSelectExamSummary: PropTypes.func,
  onToggleExamSummary: PropTypes.func
};

export default injectIntl(ExamSummary);



// WEBPACK FOOTER //
// ./src/script/components/exam/ExamSummary.js